import { i18n } from "i18next";
//@ts-ignore
import langEs from "element-ui/lib/locale/lang/es";
//@ts-ignore
import langEn from "element-ui/lib/locale/lang/en";
//@ts-ignore
import locale from "element-ui/lib/locale";

export async function setLanguage(i18next: i18n) {
    
  const i18nextLanguage = i18next.language;

  if (
    i18nextLanguage === "es" ||
    i18nextLanguage === "es-ES" ||
    i18nextLanguage.startsWith("es")
  ) {
    await locale.use(langEs);
  } else {
    await locale.use(langEn);
  }
}
